import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/shared/lib';
import { toggleSection } from '@/store/slices/uiSlice';
import { Section } from '@/data/mockData';
import { ConsignmentTable } from '@/shared/ui';
import { ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AccordionSectionProps {
  section: Section;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({ section }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { expandedSections } = useAppSelector((state) => state.ui);
  const isExpanded = expandedSections.includes(section.id);

  const handleToggle = () => {
    dispatch(toggleSection(section.id));
  };

  return (
    <div className="w-full">
      <button
        onClick={handleToggle}
        className="flex w-full justify-between items-center py-4 text-left"
        aria-expanded={isExpanded}>
        <h2 className="text-foreground text-xl font-semibold">{t(section.title)}</h2>
        <div className={cn('transform transition-transform duration-200', isExpanded ? 'rotate-180' : '')}>
          <ChevronUp className="w-5 h-5 text-muted-foreground" />
        </div>
      </button>

      <div
        className={cn(
          'overflow-hidden transition-all duration-300',
          isExpanded ? 'max-h-[5000px] opacity-100' : 'max-h-0 opacity-0'
        )}>
        {section.tables.map((table) => (
          <ConsignmentTable key={table.id} tableId={table.id} title={t(table.title)} data={table.data} />
        ))}
      </div>
    </div>
  );
};

export default AccordionSection;
